import { useEffect } from "react";

const TAG = "data-readdy-seo-json";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
  jsonLd?: object | object[];
}

/** 在每个页面挂载时注入独立标题 / 描述 / 结构化数据，卸载时清理注入的结构化数据 */
export function useSeo({ title, description, keywords, jsonLd }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("description", description);
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
    document.querySelectorAll(`[${TAG}]`).forEach((el) => el.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach((obj) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute(TAG, "1");
        script.textContent = JSON.stringify(obj);
        document.head.appendChild(script);
      });
    }
  }, [title, description, keywords, JSON.stringify(jsonLd ?? {})]);
}

function setMeta(name: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}